/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { memo, useContext } from 'react';
import PerformanceGraph from '../../../shared/PerformanceGraph/PerformanceGraph';
import DetailSummaryComponent from '../../../shared/DetailSummaryComponent/DetailSummaryComponent';
import { MAGIC_VALUE, PreferredUnit } from '../../../shared/Utils/Constants';
import '../../../../scss/ViewDetailsTheme.scss';
import {
  getPerformanceGraphData,
  getPerformanceGraphDataNew
} from '../../../shared/Utils/Utils';
import { getMaxConvertedValueFromArray } from '../../../shared/Utils/unitHandling/unitHandling';
import { getEnergyTotalUsagesGraphValues } from '../../../shared/Utils/unitHandling/EmaasSiteKpiDataScaling';
import { getNullCheckedAggregationSummaryData } from '../../../shared/Utils/EnergyUsagesViewDetailsUtils';
import { formatCommonEnergyData } from '../../../shared/Utils/PortfolioEnergy/PortfolioEnergyVDUtils';
import {
  IAny,
  IEmaasEnergyUsageComponentDataArea
} from '../../../DashboardKPIWidgets/IEnergyManagementProps';
import { ApiContext } from '../../../../context/ApiContext';

export interface IEnergyUsagesAllUtilityDetailsComponentProps {
  data: IEmaasEnergyUsageComponentDataArea;
  forSummary?: boolean;
  forGraph?: boolean;
}
const emaasEnergyUsagesAllUtilityDetailsComponent = (
  props: IEnergyUsagesAllUtilityDetailsComponentProps
) => {
  const { data } = props;
  const apiContext = useContext(ApiContext);
  const { userPreferedUnit } = apiContext;
  let fromUnit: string;
  // if (true) {
  //   fromUnit = userPreferedUnit as any;
  // } else {
  //   fromUnit = energyMeasurementUnit;
  // }
  fromUnit =
    props.data.sourceType && props.data.sourceType.toLowerCase() === 'water'
      ? PreferredUnit.Water
      : userPreferedUnit === 'megajoule'
      ? userPreferedUnit
      : props.data.sourceType && props.data.sourceType.toLowerCase() === 'gas'
      ? apiContext.toggleEnableKwhGas
        ? PreferredUnit.Electricity
        : PreferredUnit.Gas
      : (PreferredUnit.Electricity as any);

  const {
    performanceAggregation,
    aggregationsStartDate,
    performanceAggregationApplied,
    energyMeasurementUnit,
    summary,
    sourceType
  } = data;
  const {
    conversionType,
    aggregationSummaryData,
    maxValueUnitConversion,
    aggregationsEndDate,
    deviationScaledData
  } = formatCommonEnergyData(
    data,
    fromUnit,
    apiContext.showChangeWhenData,
    true
  );

  // const graphValuesArray = getEnergyTotalUsagesGraphValues(
  //   performanceAggregation
  // );

  let maxGraphValueUnitConversion: any;

  let graphValuesArray: any;

  let comparisonData: any;

  if (props.forGraph) {
    graphValuesArray = getEnergyTotalUsagesGraphValues(performanceAggregation);
    maxGraphValueUnitConversion = getMaxConvertedValueFromArray(
      conversionType,
      fromUnit, //energyMeasurementUnit,
      graphValuesArray,
      energyMeasurementUnit
    );
    comparisonData =
      performanceAggregationApplied === 'Hourly'
        ? getPerformanceGraphData(
            performanceAggregation,
            energyMeasurementUnit,
            maxGraphValueUnitConversion.Unit,
            performanceAggregationApplied,
            conversionType
          )
        : getPerformanceGraphDataNew(
            performanceAggregation,
            energyMeasurementUnit,
            maxGraphValueUnitConversion.Unit,
            performanceAggregationApplied,
            conversionType,
            data.aggregationsStartDate,
            data.aggregationsEndDate
          );
  }

  let isNullCheckedData: IAny = {};
  if (props.forSummary) {
    isNullCheckedData = getNullCheckedAggregationSummaryData(
      aggregationSummaryData,
      summary,
      apiContext.showChangeWhenData
    );
  }
  // console.log('isNullCheckedDataisNullCheckedData', isNullCheckedData);

  // isNullCheckedData.actualUnit = getMaxConvertedValueFromArray(
  //   conversionType,
  //   fromUnit, //energyMeasurementUnit,
  //   [isNullCheckedData.actualCost],
  //   energyMeasurementUnit
  // ).Unit

  // isNullCheckedData.baselineUnit = getMaxConvertedValueFromArray(
  //   conversionType,
  //   fromUnit, //energyMeasurementUnit,
  //   [isNullCheckedData.baselineCost],
  //   energyMeasurementUnit
  // ).Unit;

  // isNullCheckedData.changeUnit = getMaxConvertedValueFromArray(
  //   conversionType,
  //   fromUnit, //energyMeasurementUnit,
  //   [isNullCheckedData.costSavings],
  //   energyMeasurementUnit
  // ).Unit;

  return (
    <div className="allUtility-performance-detail-container">
      <div>
        {props.forSummary && (
          <DetailSummaryComponent
            aggregationData={isNullCheckedData}
            measurementUnit={maxValueUnitConversion.Unit}
            detailType="detailSummaryWithoutCurrency"
            category="EnergyUsage"
            deviationScaledData={deviationScaledData}
            sourceType={sourceType}
            waterAvgUnit={energyMeasurementUnit}
            fromCarbonScopeOne={true}
          />
        )}
        {props.forGraph && (
          <PerformanceGraph
            chartSeries={comparisonData}
            startTime={aggregationsStartDate}
            endTime={aggregationsEndDate}
            aggregationType={performanceAggregationApplied}
            height={''}
            spacing={[
              MAGIC_VALUE.THIRTY,
              MAGIC_VALUE.ZERO,
              MAGIC_VALUE.ZERO,
              MAGIC_VALUE.ZERO
            ]}
            conversionType={conversionType}
          />
        )}
      </div>
    </div>
  );
};

export default memo(emaasEnergyUsagesAllUtilityDetailsComponent);
